import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../api/baseurl";
import { toast } from "react-toastify";
import "./Spinner.css";
import "react-toastify/dist/ReactToastify.css";
import { Modal } from "react-bootstrap";
import { FaMinusCircle, FaPlus, FaUser } from "react-icons/fa";
import "./hm-theme.css";

const CreateLabDetails = ({ isOpen, onRequestClose, regulated }) => {
  const navigate = useNavigate();

  const url = "/api/createAccount";
  const [labDetails, setLabDetails] = useState({
    username: "",
    role: "ROLE_LAB",
    labname: "",
    labcode: "",
    contact: "",
    description: "",
    pan: "",
    gstin: "",
    tan: "",
    addressLine1: "",
    addressLine2: "",
    city: "",
    pincode: "",
    state: "",
    createddate: "",
    latitude: "",
    longitude: "",
    labDetails: {
      username: "",
      labname: "",
      labcode: "",
      contact: "",
      description: "",
      pan: "",
      gstin: "",
      tan: "",
      addressLine1: "",
      addressLine2: "",
      city: "",
      pincode: "",
      state: "",
      createddate: "",
      latitude: "",
      longitude: "",
      sendNotification: false,
      regulated: false,
      labProfileImage: {
        image: null,
        imageMeta: "",
      },
      labCoordinators: [
        {
          coOrdinatorName: "",
          coOrdinatorEmail: "",
          coOrdinatorMobileno: "",
        },
      ],
    },
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const token = JSON.parse(localStorage.getItem("data")).token;

    try {
      const emailCheckResponse = await axios.get(
        `/api/accounts/getByEmail=${labDetails.username}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (emailCheckResponse.data) {
        toast.error("Email already exists.");
        setLoading(false);
        return;
      }
    } catch (error) {
      handleError(error);
      setLoading(false);
      return;
    }

    try {
      await axios.post(
        url,
        {
          username: labDetails.username,
          role: "ROLE_LAB",
          labDetails: {
            username: labDetails.username,
            labname: labDetails.labname,
            labcode: labDetails.labcode,
            contact: labDetails.contact,
            description: labDetails.description,
            pan: labDetails.pan,
            gstin: labDetails.gstin,
            tan: labDetails.tan,
            addressLine1: labDetails.addressLine1,
            addressLine2: labDetails.addressLine2,
            city: labDetails.city,
            pincode: labDetails.pincode,
            state: labDetails.state,
            createddate: labDetails.createddate,
            latitude: labDetails.latitude,
            longitude: labDetails.longitude,
            sendNotification: labDetails.labDetails.sendNotification,
            regulated: regulated,
            labProfileImage: labDetails.labDetails.labProfileImage,
            labCoordinators: labDetails.labDetails.labCoordinators,
          },
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      setLoading(false);
      onRequestClose();
      setLabDetails({
        ...labDetails,
        username: "",
        labname: "",
        labcode: "",
        contact: "",
        description: "",
      });
      toast.success("Lab account created successfully and password sent to their email.");
    } catch (error) {
      setLoading(false);
      handleError(error);
    }
  };

  function handleError(error) {
    if (error.response) {
      if (error.response.status === 401) {
        navigate(`/signin`);
        toast.error("Your session has expired. Please login.");
      } else if (error.response.data && error.response.data.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error("An error occurred.");
      }
    } else if (error.message) {
      toast.error(error.message);
    } else {
      toast.error("An error occurred.");
    }
  }

  function rhandle(e) {
    const { id, value } = e.target;
    setLabDetails((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  }

  const handleSendNotificationChange = (e) => {
    const { checked } = e.target;
    setLabDetails((prevState) => ({
      ...prevState,
      labDetails: {
        ...prevState.labDetails,
        sendNotification: checked,
      },
    }));
  };

  const handleAddCoordinator = () => {
    setLabDetails((prevState) => ({
      ...prevState,
      labDetails: {
        ...prevState.labDetails,
        labCoordinators: [
          ...prevState.labDetails.labCoordinators,
          { coOrdinatorName: "", coOrdinatorEmail: "", coOrdinatorMobileno: "" },
        ],
      },
    }));
  };

  const handleRemoveCoordinator = (index) => {
    const newCoordinators = labDetails.labDetails.labCoordinators.filter((_, i) => i !== index);
    setLabDetails((prevState) => ({
      ...prevState,
      labDetails: {
        ...prevState.labDetails,
        labCoordinators: newCoordinators,
      },
    }));
  };

  const handleCoordinatorChange = (e, index) => {
    const { id, value } = e.target;
    const updatedCoordinators = labDetails.labDetails.labCoordinators.map((coordinator, i) => {
      if (i === index) {
        return { ...coordinator, [id]: value };
      }
      return coordinator;
    });

    setLabDetails((prevState) => ({
      ...prevState,
      labDetails: {
        ...prevState.labDetails,
        labCoordinators: updatedCoordinators,
      },
    }));
  };

  return (
    <Modal show={isOpen} onHide={onRequestClose} centered size="lg">
      <Modal.Header closeButton className="hm-card-header">
        <Modal.Title className="hm-card-title">
          <i className="material-icons">domain</i>
          Create Lab Details
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">
        {loading && <div className="loading"></div>}
        <form onSubmit={handleSubmit}>
          {/* General Lab Info */}
          <div className="mb-4">
            <h6 className="fw-bold mb-3 d-flex align-items-center gap-2" style={{ color: "#2f3a88" }}>
              <i className="material-icons" style={{ fontSize: "1.1rem" }}>local_hospital</i>
              General Information
            </h6>
            <div className="row g-3">
              <div className="col-md-6">
                <label htmlFor="labname" className="form-label small fw-semibold">
                  Lab Name <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  id="labname"
                  type="text"
                  placeholder="Enter Lab Name"
                  value={labDetails.labname || ""}
                  onChange={rhandle}
                  required
                />
              </div>

              <div className="col-md-6">
                <label htmlFor="labcode" className="form-label small fw-semibold">
                  Lab Code <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  id="labcode"
                  type="text"
                  placeholder="Enter Lab Code"
                  value={labDetails.labcode || ""}
                  onChange={rhandle}
                  required
                />
              </div>

              <div className="col-md-6">
                <label htmlFor="username" className="form-label small fw-semibold">
                  Email <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  id="username"
                  type="email"
                  placeholder="name@lab.com"
                  value={labDetails.username || ""}
                  onChange={rhandle}
                  required
                />
              </div>

              <div className="col-md-6">
                <label htmlFor="contact" className="form-label small fw-semibold">
                  Contact Number <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  id="contact"
                  type="text"
                  placeholder="Contact Number"
                  value={labDetails.contact || ""}
                  onChange={rhandle}
                  required
                />
              </div>
            </div>
          </div>

          {/* Tax Identifiers */}
          <div className="mb-4 pt-3 border-top">
            <h6 className="fw-bold mb-3 d-flex align-items-center gap-2" style={{ color: "#2f3a88" }}>
              <i className="material-icons" style={{ fontSize: "1.1rem" }}>receipt_long</i>
              Tax Identifiers
            </h6>
            <div className="row g-3">
              <div className="col-md-4">
                <label htmlFor="gstin" className="form-label small fw-semibold">
                  GSTIN
                </label>
                <input
                  className="form-control"
                  id="gstin"
                  type="text"
                  placeholder="GSTIN"
                  value={labDetails.gstin || ""}
                  onChange={rhandle}
                />
              </div>

              <div className="col-md-4">
                <label htmlFor="pan" className="form-label small fw-semibold">
                  PAN
                </label>
                <input
                  className="form-control"
                  id="pan"
                  type="text"
                  placeholder="PAN"
                  value={labDetails.pan || ""}
                  onChange={rhandle}
                />
              </div>

              <div className="col-md-4">
                <label htmlFor="tan" className="form-label small fw-semibold">
                  TAN
                </label>
                <input
                  className="form-control"
                  id="tan"
                  type="text"
                  placeholder="TAN"
                  value={labDetails.tan || ""}
                  onChange={rhandle}
                />
              </div>
            </div>
          </div>

          {/* Lab Address */}
          <div className="mb-4 pt-3 border-top">
            <h6 className="fw-bold mb-3 d-flex align-items-center gap-2" style={{ color: "#2f3a88" }}>
              <i className="material-icons" style={{ fontSize: "1.1rem" }}>location_on</i>
              Lab Address
            </h6>
            <div className="row g-3">
              <div className="col-md-6">
                <label htmlFor="addressLine1" className="form-label small fw-semibold">
                  Address Line 1 <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  id="addressLine1"
                  type="text"
                  placeholder="Address Line 1"
                  value={labDetails.addressLine1 || ""}
                  onChange={rhandle}
                  required
                />
              </div>

              <div className="col-md-6">
                <label htmlFor="addressLine2" className="form-label small fw-semibold">
                  Address Line 2
                </label>
                <input
                  className="form-control"
                  id="addressLine2"
                  type="text"
                  placeholder="Address Line 2"
                  value={labDetails.addressLine2 || ""}
                  onChange={rhandle}
                />
              </div>

              <div className="col-md-6">
                <label htmlFor="latitude" className="form-label small fw-semibold">
                  Latitude
                </label>
                <input
                  className="form-control"
                  id="latitude"
                  type="text"
                  placeholder="Latitude"
                  value={labDetails.latitude || ""}
                  onChange={rhandle}
                />
              </div>

              <div className="col-md-6">
                <label htmlFor="longitude" className="form-label small fw-semibold">
                  Longitude
                </label>
                <input
                  className="form-control"
                  id="longitude"
                  type="text"
                  placeholder="Longitude"
                  value={labDetails.longitude || ""}
                  onChange={rhandle}
                />
              </div>

              <div className="col-md-4">
                <label htmlFor="city" className="form-label small fw-semibold">
                  City <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  id="city"
                  type="text"
                  placeholder="City"
                  value={labDetails.city || ""}
                  onChange={rhandle}
                  required
                />
              </div>

              <div className="col-md-4">
                <label htmlFor="pincode" className="form-label small fw-semibold">
                  Pincode <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  id="pincode"
                  type="text"
                  placeholder="Pincode"
                  value={labDetails.pincode || ""}
                  onChange={rhandle}
                  required
                />
              </div>

              <div className="col-md-4">
                <label htmlFor="state" className="form-label small fw-semibold">
                  State <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  id="state"
                  type="text"
                  placeholder="State"
                  value={labDetails.state || ""}
                  onChange={rhandle}
                  required
                />
              </div>
            </div>
          </div>

          {/* Lab Coordinators */}
          <div className="mb-4 pt-3 border-top">
            <div className="d-flex align-items-center justify-content-between mb-3">
              <div className="d-flex align-items-center gap-2">
                <h6 className="fw-bold mb-0 d-flex align-items-center gap-2" style={{ color: "#2f3a88" }}>
                  <FaUser style={{ fontSize: "0.95rem" }} />
                  Lab Co-ordinators
                </h6>
                <span className="hm-badge hm-badge-primary">
                  {labDetails.labDetails.labCoordinators.length} Added
                </span>
              </div>
              <button
                type="button"
                className="btn btn-sm btn-outline-primary rounded-pill d-flex align-items-center gap-1"
                onClick={handleAddCoordinator}
              >
                Add Co-ordinator
              </button>
            </div>

            {labDetails.labDetails.labCoordinators.map((coordinator, index) => (
              <div
                key={index}
                className="p-3 mb-3 border rounded-3 position-relative"
                style={{ background: "rgba(248, 250, 252, 0.5)" }}
              >
                <div className="d-flex align-items-center justify-content-between mb-2">
                  <span className="small fw-semibold text-muted">Co-ordinator #{index + 1}</span>
                  {labDetails.labDetails.labCoordinators.length > 1 && (
                    <button
                      type="button"
                      className="btn btn-outline-danger btn-sm rounded-circle p-1 d-flex align-items-center justify-content-center"
                      style={{ width: "24px", height: "24px" }}
                      onClick={() => handleRemoveCoordinator(index)}
                      title="Remove Co-ordinator"
                    >
                      <FaMinusCircle style={{ fontSize: "0.75rem" }} />
                    </button>
                  )}
                </div>
                <div className="row g-3">
                  <div className="col-md-4">
                    <label className="form-label small fw-semibold">
                      Name <span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control"
                      id="coOrdinatorName"
                      type="text"
                      value={coordinator.coOrdinatorName}
                      placeholder="Co-ordinator Name"
                      onChange={(e) => handleCoordinatorChange(e, index)}
                      required
                    />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label small fw-semibold">
                      Email <span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control"
                      id="coOrdinatorEmail"
                      type="email"
                      value={coordinator.coOrdinatorEmail}
                      placeholder="Co-ordinator Email"
                      onChange={(e) => handleCoordinatorChange(e, index)}
                      required
                    />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label small fw-semibold">
                      Phone <span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control"
                      id="coOrdinatorMobileno"
                      type="text"
                      value={coordinator.coOrdinatorMobileno}
                      placeholder="Mobile Number"
                      onChange={(e) => handleCoordinatorChange(e, index)}
                      required
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Footer Actions */}
          <div className="d-flex align-items-center justify-content-between pt-3 border-top">
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                id="sendNotification"
                checked={labDetails.labDetails.sendNotification}
                onChange={handleSendNotificationChange}
              />
              <label className="form-check-label small fw-semibold" htmlFor="sendNotification">
                Send Notification
              </label>
            </div>

            <div className="d-flex align-items-center gap-2">
              <button
                type="button"
                className="btn btn-outline-secondary rounded-pill px-4"
                onClick={onRequestClose}
              >
                Close
              </button>
              <button type="submit" className="btn-hm-primary px-4" disabled={loading}>
                {loading ? "Saving..." : "Save Lab Details"}
              </button>
            </div>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default CreateLabDetails;

